import base from '@/api/base'

export default {
    async getTeamActivity() {
        return await base.get('dashboard/activity')
    },
}